import  React from 'react';

//One progress step inside ProgessMenu
export const ProgressStep = ( {number , active, completed, disabled} ) => {

  return(
    <div className={"progress-step" + (active ? " active" : "" ) + (completed ? " completed" : "") + (disabled ? " disabled" : "")}>
      <span>{number}</span>
    </div>
  );
}
